import React, { useState } from 'react';
import productData from './data/productData';
import Header from './components/Header';
import ProductCard from './components/ProductCard';
import Cart from './components/Cart';
import Footer from './components/Footer';
import { CartProvider } from './context/CartContext';

function App() {
  const [isCartOpen, setIsCartOpen] = useState(false);

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  return (
    <CartProvider>
      <div 
        className="min-h-screen bg-no-repeat bg-cover bg-fixed text-gray-800 font-sans flex flex-col"
        style={{ backgroundImage: "url('/background.png')" }}
      >
        <Header onToggleCart={toggleCart} />
        <main className="container mx-auto px-4 py-8 pt-16 sm:pt-20 flex-grow">
          <div className="flex flex-col lg:flex-row lg:space-x-8 items-start max-w-screen-xl mx-auto">
            {/* Product Grid Section */}
            <div className="w-full lg:flex-1 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start mb-8 lg:mb-0">
              {productData.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
            
            {/* Cart Section (Now a Drawer) - remove fixed positioning from here if Cart component handles it */}
            {/* The old sticky cart div is removed. Cart component will be rendered as a drawer. */}
          </div>
        </main>
        {/* Render Cart component as a drawer, controlled by isCartOpen */}
        <Cart isOpen={isCartOpen} onClose={toggleCart} />
        <Footer />
      </div>
    </CartProvider>
  );
}

export default App;
